import {AnimatePresence, motion} from 'motion/react';
import {useEffect, useMemo, useState} from 'react';
import {useLocation, useSearchParams} from 'react-router-dom';
import {APP_ANIMATIONS} from '@/const';
import Screen from '@/ui/Screen';
import ForgotForm from './components/ForgotForm';
import LoginForm from './components/LoginForm';
import ResetForm from './components/ResetForm';
import SignUpForm from './components/SignUpForm';
import {AUTH_PATHNAME, AuthSteps} from './interface';
import styles from './styles.module.scss';

const Auth = () => {
    const {pathname} = useLocation();
    const [step, setStep] = useState(pathname === AUTH_PATHNAME.login ? AuthSteps.login : AuthSteps.signup);
    const [searchParams] = useSearchParams();

    const steps = useMemo(
        () => [
            {name: AuthSteps.login, Form: LoginForm},
            {name: AuthSteps.signup, Form: SignUpForm},
            {name: AuthSteps.forgot, Form: ForgotForm},
            {name: AuthSteps.reset, Form: ResetForm}
        ],
        []
    );

    useEffect(() => {
        searchParams.has('login') && searchParams.has('key') && setStep(AuthSteps.reset);
    }, [searchParams]);

    return (
        <Screen
            screenStyles={[styles.screen]}
            screenDescription={'Maximize your traffic revenue — partner with Related Ads today'}
        >
            <AnimatePresence mode={'wait'}>
                {steps.map(({name, Form}) => {
                    return (
                        step === name && (
                            <motion.div key={name} {...APP_ANIMATIONS.fadeInOut} className={styles.motion}>
                                <Form setStep={setStep} />
                            </motion.div>
                        )
                    );
                })}
            </AnimatePresence>
        </Screen>
    );
};

export default Auth;
